import * as actionTypes from "Application/Store/Actions/CollisionTypes"

const initialState = {
    isInterferenceEnabled: false,
    isStripingEnabled: false,
}

/**
 * Update State
 * @param {object} state
 * @param {*} action
 * @returns
 */
export const CollisionReducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_INTERFERENCE:
          return {
            ...state,
            isInterferenceEnabled: action.payload,
          }
        case actionTypes.SET_STRIPING:
          return {
            ...state,
            isStripingEnabled: action.payload
          }
        default:
          return state
      }
}
